import NGIconButton from '@NGComponents/NGIconButton';
import NGText from '@NGComponents/NGText';
import AnimatedArrow from '@components/common/AnimatedArrow';
import Flex from '@layouts/Flex';
import styled from 'styled-components';
import { EToastVariant } from './Toast.enum';
import { MORE_DETAILS_WIDTH } from './Toast.variables';

export const StyledToastContainer = styled.li`
	width: 100%;
`;

export const FlexEx = styled(Flex)<{ onClick: (event: React.MouseEvent<HTMLDivElement>) => void }>``;

export const FlexToastContentContainer = styled(Flex)<{ variant: EToastVariant }>(
	({ theme, variant }) => `
    background-clip: border-box;
    background-image: url('/assets/toasts/toast-bg.webp');
    background-repeat: repeat;
    border: ${theme.spacing['6xs']} solid rgba(159, 140, 108, 0.15);
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.15), inset 0px 4px 4px rgba(0, 0, 0, 0.05);
    border-radius: 4px;

    p {
      font-size: 12px !important;
      line-height: 14px !important;
    }

    :after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      height: ${theme.spacing['5xs']};
      ${variant === EToastVariant.error ? `background-color: ${theme.colors.error}` : ''};
      ${variant === EToastVariant.success ? `background-color: ${theme.colors.success}` : ''};
      ${variant === EToastVariant.information ? `background-color: ${theme.colors.information}` : ''};
    }
  `
);

export const NGIconButtonEx = styled(NGIconButton)(
	({ theme }) => `
    position: absolute;
    top: 0;
    right: 0;
    padding: ${theme.spacing['5xs']} ${theme.spacing['5xs']} 0 0;

    & i::before {
      font-weight: 900;
    }
  `
);

export const StyledShieldContainer = styled.div`
	position: relative;
	margin-top: -14px;
	margin-right: -44px;
	z-index: 10;
	height: 82px;
	width: 57px;
	min-width: 57px;
`;

export const NGTextEx = styled(NGText)`
	position: absolute;
	left: 0;
	top: 0;
	width: ${MORE_DETAILS_WIDTH};
`;

export const AnimatedArrowEx = styled(AnimatedArrow)`
	position: absolute;
	top: 0;
	left: ${MORE_DETAILS_WIDTH};
	${({ theme }) => `padding-left: ${theme.spacing['5xs']}`}
`;
